import type { OsanoConsent } from './types';

export type GoogleConsentModeUpdate = {
  analytics_storage: 'granted' | 'denied';
  ad_storage: 'granted' | 'denied';
  ad_user_data: 'granted' | 'denied';
  ad_personalization: 'granted' | 'denied';
};

/**
 * Map an Osano consent snapshot to Google Consent Mode v2 update payload.
 * When consent is missing (CMP not ready), treat as fully denied.
 */
export function consentToGoogleConsentModeUpdate(
  consent: OsanoConsent | undefined,
): GoogleConsentModeUpdate {
  // Osano IAB/CCPA "OPT-OUT" category: value ACCEPT means the user has enabled
  // the opt-out (e.g. "Do Not Sell") — not "accept tracking." See Osano CMP JS API:
  // https://developers.osano.com/cmp/javascript-api/developer-documentation-consent-javascript-api
  // ("onOptOut" / Consent Object). When true, we deny ad_* regardless of MARKETING.
  const optedOutOfSale = consent?.['OPT-OUT'] === 'ACCEPT';
  const analytics = consent?.ANALYTICS === 'ACCEPT';
  const marketingAllowed =
    consent?.MARKETING === 'ACCEPT' && !optedOutOfSale;
  const personalization = consent?.PERSONALIZATION === 'ACCEPT';

  return {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketingAllowed ? 'granted' : 'denied',
    ad_user_data: marketingAllowed ? 'granted' : 'denied',
    ad_personalization:
      marketingAllowed && personalization ? 'granted' : 'denied',
  };
}
